<template>
  <div class="refuseInvitation defatult-bg">
    <div class="text">
      本次活动已结束，感谢您对高毅资产的信任和支持！
    </div>
    <footer-message style="color: #fff;"></footer-message>
  </div>
</template>

<script>
import footerMessage from './../../components/footer-message.vue'

export default {
  name: "Complete2023",
  data () {
    return {
    }
  },
  mounted () {
  },
  components: {
    'footer-message': footerMessage
  }
}
</script>

<style lang="less">
.refuseInvitation {
  height: 100vh !important;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 46px;
  box-sizing: border-box;

  .text {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #fff;
  }
}
</style>
